import React, { useState, useEffect } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'
import _ from 'lodash'
import api from '../api'
import { setKeysSets } from '../redux/actions/keysSetsActions'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import BalanceCard from 'components/BalanceCard/BalanceCard'

const BalancesWS = () => {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const keysSets = useSelector(state => state.keysSets)
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))

  useEffect(() => {
    if (user && user.cid) {
      api
        .getCompanyKeys(user.cid)
        .then(res => {
          if (res.KeysSets) {
            console.log('[getCompanyKeys]')
            dispatch(setKeysSets(res.KeysSets))
          }
        })
        .catch(e => console.error('getCompanyKeys error ', e))
    }
  }, [user])

  return (
    <div className='content balances-wrapper'>
      <h2>{t('balances.title')}</h2>
      {user && user.cid &&
        <>
          <BalanceCard cid={user.cid} isTotal={true}/>
          <ResponsiveMasonry 
            columnsCountBreakPoints={{766: 1, 767: 2, 991: 3}}
            gutterBreakPoints={{766: '10px', 767: '15px', 991: '20px'}} >
            <Masonry className='balances-wrapper'>

              {(keysSets.keysSets && keysSets.keysSets.length > 0) && _.map(keysSets.keysSets, (ks, key) => {
                return <BalanceCard cid={user.cid} botId={ks.id} name={ks.name} key={key} />
              })}
            </Masonry>
          </ResponsiveMasonry>
        </>}

      
    </div>
  )
}

export default BalancesWS